<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {onMounted, ref, computed, nextTick} from "vue";
import {useRoute, useRouter} from "vue-router";
import axios from "axios";
import {useHead} from "@vueuse/head";


const route = useRoute()
const router = useRouter()
const blogList = ref(null);
const current = ref(1)


async function get_blog_list() {
  try {
    let url = '/api/blogs';
    const title = route.query.blog_title;
    const page = Number(route.query.page);
    const params = new URLSearchParams();

    if (title) {
      params.append('blog_title', title);
    }
    if (page) {
      params.append('page', page);
    }

    url = url + '?' + params.toString();
    const response = await axios.get(url);
    blogList.value = response.data;
  } catch (error) {
    console.log(error);
  }
}

const lastPage = computed(() => {
  return Math.ceil(blogList.value.count / 12)
})

const prevPage = computed(() => {
  if (current.value > 1) {
    return current.value - 1;
  } else {
    return 1
  }
})

const nextPage = computed(() => {
  if (current.value < lastPage.value) {
    return current.value + 1
  } else {
    return current.value
  }
})

const pages = computed(() => {
  const pages = []
  for (let i = 1; i <= lastPage.value; i++) {
    if (i === current.value || i === lastPage.value || (i >= current.value - 1 && i <= current.value + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...')
    }
  }
  return pages
})


function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}

function getPageFromUrl() {
  const page = route.query.page
  return page ? page : 1
}

function getToPage(page) {
  current.value = page
  const query = {...route.query}
  query.page = page
  router.push({
    query
  })
}

onMounted(async () => {
  const scripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  await loadScriptsSequentially(scripts);
  current.value = await getPageFromUrl()
  await get_blog_list()
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})
</script>

<template>
  <Header/>
  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>Blog</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>Blog</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_blog_area  -->
  <div class="kurigram_blog2_area blog_pag">
    <div class="container">
      <div class="row">
        <!-- kurigram_blog_01  -->
        <div class="col-lg-4 col-md-6 col-sm-12" v-if="blogList && blogList.results"
             v-for="list in blogList.results">
          <div class="kurigram-single-blog">
            <div class="kurigram-blog-thumb">
              <a :href="'/blogs/' + list.site"> <img :src="list.image_1" alt=""> </a>
            </div>
            <div class="em-blog-content-area">
              <div class="blog-page-title">
                <h2><a :href="'/blogs/' + list.site">{{ list.blog_title }}</a></h2>
              </div>
              <!-- BLOG POST META  -->
              <div class="kurigram-blog-meta">
                <div class="kurigram-blog-meta-left">
                  <span><i class="fas fa-calendar-alt"></i>{{ formatDate(list.updated_at) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- START PAGINATION -->
  <div class="row">
    <div class="col-md-12">
      <div class="paginations">
        <ul class='page-numbers'>
          <li @click="getToPage(prevPage)"><a class="next page-numbers" href="javascript:void(0)" onclick="location.reload()"><i
              class="fa fa-long-arrow-left"></i></a></li>
          <li v-if="blogList && blogList.results" v-for="page in pages" :key="page">
            <a  v-if="page === current.value" @click="getToPage(page)" class='page-numbers' href="javascript:void(0)" onclick="location.reload()">{{ page }}</a>
            <a v-else-if="page === '...'" @click="getToPage(page)" class='page-numbers' href="javascript:void(0)" onclick="location.reload()">{{ page }}</a>
            <a v-else @click="getToPage(page)" class='page-numbers' href="javascript:void(0)" onclick="location.reload()">{{ page }}</a>
          </li>
          <li @click="getToPage(nextPage)"><a class="next page-numbers" href="javascript:void(0)" onclick="location.reload()"><i class="fa fa-long-arrow-right"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </div>


  <Footer/>
</template>

<style scoped lang="scss">

</style>